export default __webpack_public_path__ + "static/media/linkeding.9ce78606.svg";